<template>
    <div class="empty-wrap">
        <div>
            <div class="image-wrap"/>
            <p v-html="content"></p>
        </div>
    </div>
</template>
<script>
    export default{
        props: ['content']
    }
</script>
